import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { store } from './app/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import ReactGA from "react-ga4";

import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { GOOGLE_ANALYTICS_TOKEN } from './config';
import { CookiesProvider } from 'react-cookie';

ReactGA.initialize(GOOGLE_ANALYTICS_TOKEN);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <CookiesProvider>
          <App />
        </CookiesProvider>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// https://www.npmjs.com/package/react-webcam

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();